import { Col, Form, Row } from "antd";
import AButton from "core/presentation/components/Button";
import AText from "core/presentation/components/Text";
import ATitle from "core/presentation/components/Title";
import { useNavigate } from "react-router-dom";
import { typography } from "theme/Typography";
import { useAppSelector } from "core/presentation/store/hooks";
import OnTimeDeliveryRate from "./OnTimeDeliveryRate";
import { Summary } from "./Summary";
import NoOfVehicles from "./NoOfVehicles";
import IncomeDistribution from "./IncomeDistribution";
import VehicleOwnerList from "./VehicleOwnerList";
import ShipperList from "./ShipperList";
import VehicleLocations from "./VehicleLocations";
import TripDetailsList from "./TripDetailsList";
import DriverDetailsList from "./DriverDetailsList";
import { userThunks } from "user/presentation/store/userSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Loader from "core/presentation/components/Loader";

const PlatformAdminMainDashboard = () => {
  const { userProfile } = useAppSelector((state) => state.user);
  const name = `${userProfile?.user?.firstName}`;
  const navigate = useNavigate();
  const handleCreateOrder = () => {
    navigate("/orders/create");
  };

  const userRole = userProfile?.user?.roles[0]?.roleCode;
  return (
    <>
      <div>
        <ATitle
          content={`Welcome Back, ${name}`}
          style={{ fontSize: typography.fontSizes.threexl }}
        />
        <AText>
          Track, manage and view Shippers, Drivers & Vehicle Owners.Track,
          manage and view your shipments.
        </AText>
      </div>
      <Row>
        <Summary />
      </Row>
      <Row gutter={[20, 20]}>
        <Col md={12}>
          <NoOfVehicles />
        </Col>
        <Col md={12}>
          <OnTimeDeliveryRate />
        </Col>
      </Row>
      {userRole !== "SUPER_ADMIN" && (
        <>
          {userProfile?.user?.permissions.includes(
            "vehicle_owner:list_all"
          ) && (
            <>
              <Row gutter={[20, 20]} style={{ marginTop: "2rem" }}>
                <Col md={24}>
                  <VehicleLocations />
                </Col>
              </Row>
              <VehicleOwnerList />
            </>
          )}
          {userProfile?.user?.permissions.includes("trip:list_all") && (
            <TripDetailsList />
          )}
          {userProfile?.user?.permissions.includes("shipper:list_all") && (
            <ShipperList />
          )}
          {userProfile?.user?.permissions.includes("driver:list_all") && (
            <DriverDetailsList />
          )}
        </>
      )}
    </>
  );
};

export default PlatformAdminMainDashboard;
